import React from 'react';

import { themeStyle } from '@repo/ui/theming';
import IconLucideBell from '@repo/ui-icons/IconLucideBell';
import { H4, P2 } from '@repo/ui-kit/components/core/Typography';

import { FlexColumn, FlexRow } from 'styles/layouts';

import { getSectionIcon } from '../iconUtils';

import { IconWrapper } from './styles';
import { CalloutFeatureProps } from './types';

export const CalloutFeature: React.FC<CalloutFeatureProps> = ({
  text,
  description,
  icon,
}) => {
  const Icon = getSectionIcon(icon, IconLucideBell)!;

  return (
    <FlexRow alignItems="center" gap="20px">
      <IconWrapper>
        <Icon color={themeStyle.varInkMain} size={29} />
      </IconWrapper>
      <FlexColumn gap="8px">
        <H4 bold>{text}</H4>
        <P2>{description}</P2>
      </FlexColumn>
    </FlexRow>
  );
};
